// src/pages/team/TeamCreatePage.tsx
// Legacy route kept resolvable for old links/bookmarks. Team creation now
// happens through TeamCreateDialog (form-kit), opened from TeamListPage's
// "+ New" — see docs/ux/14-forms.md. This route just sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const TeamCreatePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/teams', { replace: true });
  }, [navigate]);
  return null;
};

export default TeamCreatePage;
